import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const ThumbSide = ({
  customPythons,
  currentCustomPython,
  onCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="THUMB SIDE COLOR"
      className="finger-side-color-wrap"
      images={customPythons}
      currentCustomImage={currentCustomPython}
      onClick={onCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { thumbSidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    currentCustomPython: thumbSidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onCustomPythonClick: color => dispatch(updateGlove({ thumbSidePython: color })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThumbSide), 'webSide');
